import { styled } from "@mui/material";
import { Box } from "@mui/material";

export const PaneBody = styled('div')({
  height: '100%',
  width: '100%',
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

export const Overlay = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 2,
});

export const ErrorText = styled('div')({
  textAlign: 'center',
  padding: '16px',
});

export const PromoBoxContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
}));
